var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgWave = function SvgWave(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    strokeWidth: 4,
    stroke: "currentColor",
    viewBox: "0 0 1350 114"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "wave_svg__wave-path",
    strokeDasharray: "1423.34px 1423.34px",
    d: "M.56 55.78c466.67 188 933.33-188 1400 0"
  })));
};
export default SvgWave;